module.exports = __webpack_public_path__ + "img/personal11.ddf98cf3.png";